import { Button, ButtonGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import React from 'react';
import { camelCase } from 'lodash';
import NoteCircleIcon from './noteCircleIcon';
import { checkPermission, makeResource } from '../../../../behaviors/src/lib/permissions';
import ColorSelectorModal from '../controls/colorSelectorModal';
const AnnotationsEditBar = _ref => {
  let setEditType = _ref.setEditType,
    _ref$selectedType = _ref.selectedType,
    selectedType = _ref$selectedType === void 0 ? null : _ref$selectedType,
    selectedColor = _ref.selectedColor,
    setEditColor = _ref.setEditColor,
    _ref$toolbar = _ref.toolbar,
    toolbar = _ref$toolbar === void 0 ? null : _ref$toolbar,
    _ref$user = _ref.user,
    user = _ref$user === void 0 ? {} : _ref$user;
  // Helper to build composite identifier
  const getAnnotationIdentifier = tool => {
    const render = tool.renderType ? camelCase(tool.renderType) : '';
    const formTypeIdentifier = tool.formTypeIdentifier && tool.formTypeIdentifier ? "__".concat(camelCase(tool.formTypeIdentifier)) : '';
    return "".concat(render).concat(formTypeIdentifier);
  };

  // Check if user has permission to see toolbar button for a formTypeIdentifier
  const hasToolbarPermission = formTypeIdentifier => {
    if (!formTypeIdentifier || !user || !user.permissions) {
      return true; // Default to visible if no permission context
    }
    return checkPermission(makeResource('form', formTypeIdentifier), ['view_detail', 'create', 'edit'], user.permissions, user);
  };
  const selectType = newType => {
    if (selectedType !== newType) {
      setEditType(newType);
    } else {
      setEditType(null);
    }
  };
  const imgStyle = {
    width: '20px',
    paddingBottom: '20px'
  };
  const btnStyle = {
    height: '34px'
  };

  // Use toolbar.annotationTools if provided, otherwise default list
  let buttonIdentifiers;
  let buttonConfigs = null;
  if (toolbar !== null && toolbar !== undefined) {
    // If toolbar is provided (even if empty), only use its annotationTools
    if (Array.isArray(toolbar.annotationTools) && toolbar.annotationTools.length > 0) {
      buttonConfigs = toolbar.annotationTools.map(tool => {
        const identifier = getAnnotationIdentifier(tool);
        return {
          identifier,
          title: tool.title,
          webIcon: tool.webIcon || 'fa-pencil',
          renderType: tool.renderType,
          formTypeIdentifier: tool.formTypeIdentifier
        };
      }).filter(tool => tool.identifier);

      // Filter buttons based on permissions
      const filteredConfigs = buttonConfigs.filter(config => {
        if (!config.formTypeIdentifier) {
          return true; // Show buttons without formTypeIdentifier
        }
        return hasToolbarPermission(config.formTypeIdentifier);
      });
      buttonIdentifiers = filteredConfigs.map(tool => tool.identifier);
      buttonConfigs = filteredConfigs;
    } else {
      buttonIdentifiers = [];
    }
  } else {
    // Only use default list if toolbar is null or undefined
    buttonIdentifiers = ['ink', 'highlight', 'line', 'issue', 'freeText', 'info'];
  }

  // Show color picker if toolbar is not specified, or if showsColorPicker is true
  // AND if there are tools available after permissions filtering
  const showColorPicker = (toolbar === null || toolbar === undefined || toolbar && toolbar.showsColorPicker === true) && buttonIdentifiers.length > 0;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      paddingLeft: 15
    }
  }, showColorPicker && /*#__PURE__*/React.createElement(ColorSelectorModal, {
    selectedColor: selectedColor,
    onChange: setEditColor,
    indicatorShape: "circle",
    buttonProps: {
      'data-testid': 'color-selector'
    }
  }), /*#__PURE__*/React.createElement(ButtonGroup, {
    style: {
      paddingLeft: 10
    }
  }, buttonIdentifiers.map((next, idx) => {
    let icon = null;
    let title = next;
    let buttonKey = "annotation_select_".concat(next);
    let buttonTestId = "annotation-button-".concat(next);
    if (buttonConfigs) {
      const config = buttonConfigs[idx];
      if (config && config.identifier.startsWith('note') && config.title && (!config.webIcon || config.webIcon === 'fa-pencil')) {
        const noteTitle = config.title;
        icon = /*#__PURE__*/React.createElement(NoteCircleIcon, {
          text: noteTitle
        });
        title = noteTitle;
      } else if (config && config.webIcon) {
        icon = /*#__PURE__*/React.createElement("i", {
          className: "fa ".concat(config.webIcon),
          style: {
            fontSize: '20px'
          },
          "aria-hidden": "true"
        });
        title = config.title || next;
      }
      // Use config.identifier for key and data-testid if available
      if (config && config.identifier) {
        buttonKey = "annotation_select_".concat(config.identifier);
        buttonTestId = "annotation-button-".concat(config.identifier);
      }
    }
    return /*#__PURE__*/React.createElement(Button, {
      style: btnStyle,
      key: buttonKey,
      onClick: () => selectType(next),
      className: "t-aeb t-aeb-".concat(next, " ").concat(selectedType === next ? 't-aeb-active' : '').concat(icon && icon.props.className === 'annotation-toolbar-circle' ? ' annotation-toolbar-btn-center' : ''),
      active: next === selectedType,
      "data-testid": buttonTestId,
      title: title
    }, icon || /*#__PURE__*/React.createElement("img", {
      style: imgStyle,
      src: "/img/annotationToolbar/selected_".concat(next, ".png"),
      alt: "annotation-type-".concat(next)
    }));
  })));
};
AnnotationsEditBar.propTypes = {
  selectedType: PropTypes.string,
  setEditType: PropTypes.func.isRequired,
  selectedColor: PropTypes.string.isRequired,
  setEditColor: PropTypes.func.isRequired,
  user: PropTypes.shape({
    permissions: PropTypes.shape({})
  }),
  toolbar: PropTypes.shape({
    annotationTools: PropTypes.arrayOf(PropTypes.shape({
      renderType: PropTypes.string,
      formTypeIdentifier: PropTypes.string,
      webIcon: PropTypes.string,
      title: PropTypes.string
    })),
    showsColorPicker: PropTypes.bool
  })
};
export default AnnotationsEditBar;